export interface Booking {
    id: number;
    guestName: string;
    checkin: string;
    checkout: string;
    revenue: number;
    currency: string;
    cleaningFee: number;
}

export const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const getDatesInRange = (
    startDate: string,
    endDate: string
): string[] => {
    const dates: string[] = [];
    const current = new Date(`${startDate}T00:00:00Z`);
    const end = new Date(`${endDate}T00:00:00Z`);

    while (current < end) {
        dates.push(current.toISOString().split('T')[0]);
        current.setUTCDate(current.getUTCDate() + 1);
    }

    return dates;
};

export const getColorForCount = (count: number, maxCount: number): string => {
    if (count === 0) return '#ebedf0';
    const intensity = Math.min(count / maxCount, 1);
    const hue = 210;
    const saturation = 70;
    const lightness = 95 - intensity * 50;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
